export  const AppTheme = {
    DARK: "dark",
    LIGHT: "light"
  }